var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('RolChip',_vm._g(_vm._b({attrs:{"clickable":""},on:{"click":function($event){return _vm.edit()}},model:{value:(_vm.rol),callback:function ($$v) {_vm.rol=$$v},expression:"rol"}},'RolChip',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }